import { render } from "./QuestionRating.vue?vue&type=template&id=f712ae2e&scoped=true&ts=true"
import script from "./QuestionRating.vue?vue&type=script&lang=ts"
export * from "./QuestionRating.vue?vue&type=script&lang=ts"

import "./QuestionRating.vue?vue&type=style&index=0&id=f712ae2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f712ae2e"]])

export default __exports__